<!-- =========================================================================================
    File Name: PermissionDenied.vue
    Description: 500 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
      <div class="container mx-auto">
        <div class="h-screen flex w-full  relative">
          <div class=" vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <a-card>
              <img src="@/assets/images/pages/500.png" alt="graphic-500" class="mx-auto mb-4">
              <h1 class="sm:mx-0 mx-4 mb-4 sm:mb-8 text-2xl d-theme-heading-color">{{ whichStatusMessage().title }}</h1>
              <p class="sm:mx-0 mx-4 mb-4 sm:mb-8">{{ whichStatusMessage().message }}</p>
              <vs-button size="large" @click="routePushPlan">Buy Plan</vs-button>
            </a-card>
        </div>
        </div>
      </div>
</template>

<script>
  export default {
    name:'Permission Denied',
    methods:{
      whichStatusMessage() {
        if (this.$store.state){
          if (this.$store.state.state_account == 2)
            return { message: 'Your free trial account has been finished! Please buy a plan for your firm.', title: 'Your trial account finished.' }
          if (this.$store.state.state_account == 3)
            return { message:'Your account has been deactivated! Please renew your subscription.', title: 'Your account deactivated.' }
          if (this.$store.state.state_account == 4)
            return { message:'Your Iralex account has expired! Please renew your subscription.', title: 'Your account expired.' }
        }
      },
      routePushPlan(){
        this.$router.push({ path: '/buy-plan' })
      }
    },
  }
</script>
